import ThemeToggle from './ThemeToggle';

export default function Sidebar({
  user,
  currentPage,
  onPageChange,
  title = "Admin Panel",
  subtitle = "User management",
  children,
  onLogout,
  onNavigation
}) {
  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span className="badge">Logged in</span>
          <ThemeToggle />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '12px 0 6px' }}>
          <img 
            src={user?.picture || `https://ui-avatars.com/api/?name=${encodeURIComponent(title)}&background=f4d9cc&color=7a2c16&size=40`}
            alt={title}
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              objectFit: 'cover'
            }}
          />
          <h2 style={{ margin: 0 }}>{title}</h2>
        </div>
        {subtitle && <p>{subtitle}</p>}
        <button 
          className="logout-btn"
          onClick={() => {
            if (onLogout) onLogout();
            localStorage.clear();
            window.location.reload();
          }}
        >
          Logout
        </button>
      </div>
      <div className="nav-menu">
        <div
          className={`nav-item ${currentPage === 'daily-annotation' ? 'active' : ''}`}
          onClick={() => {
            if (onNavigation) onNavigation('daily-annotation');
            onPageChange('daily-annotation');
          }}
        >
          <span>Daily Annotation</span>
        </div>
        <div 
          className={`nav-item ${currentPage === 'history' ? 'active' : ''}`}
          onClick={() => {
            if (onNavigation) onNavigation('history');
            onPageChange('history');
          }}
        >
          <span>History</span>
        </div>
        <div
          className={`nav-item ${currentPage === 'vad-annotation' ? 'active' : ''}`}
          onClick={() => {
            if (onNavigation) onNavigation('vad-annotation');
            onPageChange('vad-annotation');
          }}
        >
          <span>VAD Annotation</span>
        </div>
        {user?.is_admin && (
          <>
            <div
              className={`nav-item ${currentPage === 'users' ? 'active' : ''}`}
              onClick={() => {
                if (onNavigation) onNavigation('users');
                onPageChange('users');
              }}
            >
              <span>User Management</span>
            </div>
            <div
              className={`nav-item ${currentPage === 'analytics' ? 'active' : ''}`}
              onClick={() => {
                if (onNavigation) onNavigation('analytics');
                onPageChange('analytics');
              }}
            >
              <span>User Analytics</span>
            </div>
            <div
              className={`nav-item ${currentPage === 'data-formation' ? 'active' : ''}`}
              onClick={() => {
                if (onNavigation) onNavigation('data-formation');
                onPageChange('data-formation');
              }}
            >
              <span>Data Formation</span>
            </div>
            <div
              className={`nav-item ${currentPage === 'eval-results' ? 'active' : ''}`}
              onClick={() => {
                if (onNavigation) onNavigation('eval-results');
                onPageChange('eval-results');
              }}
            >
              <span>STT Validation</span>
            </div>
          </>
        )}
      </div>
      {children}
    </aside>
  );
}